export interface MealPlan {
    id: string,
    user_id: string,
    data: MealPlanData,
    pdf_data: MealPlanPdfData[],
    updates_history: MealPlanDataHistory[],
    // old_data: MealPlanOldData,
    created_at: string,
    updated_at: string,
}

// export interface MealPlanOldData {
//     key_parameters: string[],
//     top_hero_foods: string[],
//     top_integratori: string[],
//     nutrition_recommendations: string[],
// }

export interface MealPlanData {
    guidelines: ClickableItem[], //v3
    recepees: ClickableItem[], //v3
    nutri_comment: ClickableItem[], //v3
    food_tips: ClickableItem[], //v3
    integrators_suggested: ClickableItem[], //v3    
    key_parameters: string[], //v2
    top_hero_foods: string[], //v2
    top_integratori: string[], //v2
    nutrition_recommendations: string[], //v2
    goal: string, //v1
    comment: string, //v1
    key_points: string[], //v1
    important_key_points: string[], //v1
}

interface MealPlanDataHistory {
    value: MealPlanData,
    date: string,
}

export enum MealPlanPdfType {
    MealPlan = "meal_plan",
    SupportMaterials = "support_materials",
}

interface MealPlanPdfData {
    file_name: string,
    s3_url: string,
    type: MealPlanPdfType,
}

// ********************************************************************************

export interface HealthPlan {
    id: string,
    user_id: string,
    data: HealthPlanData,
    pdf_data: PdfData[],
    updates_history: DataHistory[],
    created_at: string,
    updated_at: string,
}

export interface HealthPlanData {
    comment: string[],
    food_suggested: ClickableItem[],
    integrators_suggested: ClickableItem[],
    check_ups_suggested: ClickableItem[],
}

interface DataHistory {
    value: HealthPlanData,
    date: string,
}

export enum HealthPlanPdfType {
    Materials = "materials",
    Prescriptions = "prescriptions",
}

interface PdfData {
    file_name: string,
    s3_url: string,
    type: HealthPlanPdfType,
}

// ********************************************************************************

export interface ClickableItem {
    text: string,
    isChecked: boolean,
}